exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._65D6y2pQ3jngpI3b7b-Lm{margin-right:20px}._3fhG9XvaSc7o9Gg60RU2tj,._65D6y2pQ3jngpI3b7b-Lm{display:inline-block;vertical-align:top}", ""]);

// exports
exports.locals = {
	"label": "_65D6y2pQ3jngpI3b7b-Lm",
	"ratings": "_3fhG9XvaSc7o9Gg60RU2tj"
};